module.exports = __webpack_public_path__ + "img/top-logo-2.693217e7.png";